export var GanttType = /*#__PURE__*/ function(GanttType) {
    GanttType["ProjectPhaseBar"] = "PROJECT_PHASE";
    GanttType["TaskBar"] = "TASK";
    GanttType["MilestoneBar"] = "MILESTONE";
    GanttType["Sprint"] = "SPRINT";
    GanttType["Subtask"] = "SUBTASK";
    GanttType["AddNewTask"] = "ADD_NEW_TASK";
    return GanttType;
}({});
export const getGanttPhaseId = (id)=>`${"PROJECT_PHASE"}-${id}`;
export const getGanttTaskId = (id)=>`${"TASK"}-${id}`;
export const getGanttSprintId = (id)=>`${"SPRINT"}-${id}`;
